module.exports = __webpack_public_path__ + "img/series_negative_val.5f6cc36d.svg";